<template>
  <div class="hl-shop-box">
    <div>
      <strong>联创商城</strong>
      <p>由鸿联云精心挑选“质量可靠、服务优质、有口皆碑”的精品软件与服务</p>
      <div class="hl-shop-solution">
        <div class="hl-shop-title">
          <p>解决方案推荐</p>
          <span @click="$router.push('/solution')">查看更多 ></span>
        </div>
        <div class="hl-shop-solution-head">
          <p>好用、精选、场景化的行业创新解决方案</p>
          <div>
            <span
              v-for="(item, index) in solutionSortList"
              :key="index"
              :class="{ active: solutionTagIndex === index }"
              @click="solutionTag(item.id,index)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="hl-shop-solution-list">
          <div
            v-for="el in solutionList"
            :key="el.id"
            @click="solutionInfo(el.id, el.hotType)"
          >
            <p>
              {{ el.name }}
              <img v-if="el.marketing == 2" src="@/assets/img/2.0/tjicon.png" />
            </p>
            <span>{{ el.solutionDiscription }}</span>
          </div>
        </div>
      </div>
      <div class="hl-shop-iot">
        <div class="hl-shop-title">
          <p>IoT硬件</p>
          <span @click="$router.push('/replace')">查看更多 ></span>
        </div>
        <div class="hl-shop-iot-content">
          <div class="hl-shop-iot-jx">
            <img src="@/assets/img/2.0/iotjximg.png" alt="图片" />
            <div>
              <p>IoT硬件</p>
              <span>基于AIoT鸿蒙化替代升级服务，助您国产化升级</span>
            </div>
          </div>
          <div class="hl-shop-iot-list">
            <div
              v-for="el in replaceList"
              :key="el.id"
              @click="replaceInfo(el.id, el.type)"
            >
              <span>
                <v-img
                  :attachment-id="el.productCover"
                  :default-img="require('@/assets/img/kctp.png')"
                />
              </span>
              <div>
                <h4>{{ el.productName }}</h4>
                <p v-html="el.productBlurb"></p>
                <span>¥{{ el.productPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hl-shop-app">
        <div class="hl-shop-title">
          <p>服务与应用</p>
          <span @click="$router.push('/service')">查看更多 ></span>
        </div>
        <div class="hl-shop-app-content">
          <div>
            <vue-seamless-scroll
              :data="serviceList"
              ref="serviceRef1"
              :class-option="optionSingleHeight"
              class="seamless-warp"
            >
              <ul class="item">
                <li
                  v-for="(item, index) in serviceList"
                  :key="index"
                  @click="toServiceDetails(item.id)"
                >
                  <div class="hl-shop-app-list">
                    <span>
                      <v-img
                        :attachment-id="item.serviceCover"
                        :default-img="require('@/assets/img/kctp.png')"
                      />
                    </span>
                    <div>
                      <h4>{{ item.serviceName }}</h4>
                      <span>
                        {{ item.summary }}
                      </span>
                      <p v-if="item.pricingType == 1">
                        ¥{{ item.lowestPrice }}
                        <span
                          >/{{ item.buyType | buyTypeDict("BUY_TYPE") }}</span
                        >
                      </p>
                      <p v-else>议价定制</p>
                    </div>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div>
            <vue-seamless-scroll
              :data="applyList"
              ref="serviceRef2"
              :class-option="optionSingleHeight"
              class="seamless-warp"
            >
              <ul class="item">
                <li
                    v-for="(item, index) in applyList"
                    :key="index"
                    @click="toServiceDetails(item.id)"
                >
                  <div class="hl-shop-app-list">
                    <span>
                      <v-img
                          :attachment-id="item.serviceCover"
                          :default-img="require('@/assets/img/kctp.png')"
                      />
                    </span>
                    <div>
                      <h4>{{ item.serviceName }}</h4>
                      <span>
                        {{ item.summary }}
                      </span>
                      <p v-if="item.pricingType == 1">
                        ¥{{ item.lowestPrice }}
                        <span
                        >/{{ item.buyType | buyTypeDict("BUY_TYPE") }}</span
                        >
                      </p>
                      <p v-else>议价定制</p>
                    </div>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getSolutionList, getCategoryList } from "@/api/solution";
import { getNewProductList } from "@/api/iot";
import { getServicePageList } from "@/api/service";
import VImg from "@/components/VImg";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    vueSeamlessScroll,
    VImg,
  },
  data() {
    return {
      solutionTagId: 0,
      solutionTagIndex:0,
      solutionSortList: [],
      solutionList: [],
      replaceList: [],
      serviceList: [],
      applyList:[],
      listData: [
        {
          title: "无缝滚动第一行无缝滚动第一行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第二行无缝滚动第二行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第三行无缝滚动第三行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第四行无缝滚动第四行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第五行无缝滚动第五行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第六行无缝滚动第六行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第七行无缝滚动第七行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第八行无缝滚动第八行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第九行无缝滚动第九行",
          date: "2017-12-16",
        },
      ],
    };
  },
  mounted() {
    this.loadGetSolutionCategory();
    this.loadGetIotProductList();
    this.loadGetServicePageList();
    this.LoadDictData(["BUY_TYPE"]);
  },
  computed: {
    ...mapGetters(["dict"]),
    optionSingleHeight() {
      return {
        singleHeight: 104,
      };
    },
  },
  methods: {
    ...mapActions(["LoadDictData"]),
    loadGetServicePageList() {
      getServicePageList({ current: 1, size: 20 }, {isService:1}).then((res) => {
        this.serviceList = res.records;
      });
      getServicePageList({ current: 1, size: 20 }, {isService:0}).then((res) => {
        this.applyList = res.records;
      });
    },
    toServiceDetails(id) {
      this.$router.push({
        path: "/service/details",
        query: { id },
      });
    },
    // 类别列表
    loadGetSolutionCategory() {
      getCategoryList("1").then((res) => {
        let data = res;
        this.solutionSortList = data;
        // this.solutionTagId = data[0].id;
        this.solutionTagId = '1500000000000000225';
        this.loadGetSolutionList();
      });
    },
    solutionTag(id,index) {
      this.solutionTagId = id;
      this.solutionTagIndex=index
      if(index===0){
        this.solutionTagId = '1500000000000000225'; //应要求固定取智慧水利
      }
      this.loadGetSolutionList();
    },
    loadGetSolutionList() {
      getSolutionList(
        {
          current: 1,
          size: 6,
        },
        {
          category: this.solutionTagId,
        }
      ).then((res) => {
        this.solutionList = res.records;
      });
    },
    loadGetIotProductList() {
      getNewProductList({ current: 1, size: 4 }, { status: "2" }).then(
        (res) => {
          console.log("list", res);
          this.replaceList = res.records;
        }
      );
    },
    // 详情
    solutionInfo(id, type) {
      if (type == 2 || type == 3) {
        this.$router.push({
          path: "/solution/info",
          query: { id },
        });
      } else if (type == 1) {
        this.$router.push({
          path: "/solution/internet_things",
          query: { id },
        });
      } else if (type == 4 || type == 5) {
        this.$router.push({
          path: "/solution/ordinary_program",
          query: { id },
        });
      } else if (type == 6) {
        this.$router.push({
          path: "/solution/digitizing",
          query: { id },
        });
      }
    },
    replaceInfo(id, type) {
      // if (type === "iot") {
      this.$router.push({
        path: "/replace/newInfo",
        query: { id },
      });
      // } else {
      //   this.$router.push({
      //     path: `/replace/productInfo/${type}`,
      //     query: { id },
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.hl-shop-box {
  padding: 64px 0 56px;
  background: #fff;
  > div {
    width: 1280px;
    margin: 0 auto;
    > strong {
      display: block;
      font-size: 32px;
      line-height: 45px;
      color: #262626;
      text-align: center;
      margin-bottom: 16px;
    }
    > p {
      font-size: 18px;
      line-height: 25px;
      color: #000;
      margin-bottom: 60px;
      text-align: center;
    }
    .hl-shop-solution {
      margin-bottom: 48px;
    }
    > div {
      .hl-shop-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
        > p {
          font-weight: bold;
          font-size: 28px;
          color: #000000;
          line-height: 32px;
          position: relative;
          padding-left: 12px;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 3px;
            width: 4px;
            height: 26px;
            background: #ea0b06;
          }
        }
        > span {
          cursor: pointer;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
        }
      }
      .hl-shop-solution-head {
        padding: 40px 24px 0;
        background: url(../../assets/img/2.0/jjfatjbg.jpg) no-repeat;
        background-size: 100% 100%;
        > p {
          font-size: 20px;
          color: #262626;
          line-height: 28px;
          font-weight: bold;
          margin-bottom: 66px;
        }
        > div {
          display: flex;
          > span {
            margin-right: 56px;
            font-size: 16px;
            color: #262626;
            line-height: 22px;
            padding-bottom: 16px;
            position: relative;
            cursor: pointer;
            transition: all 0.3s;
            &::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              z-index: 2;
              background: #ea0b06;
              height: 3px;
              opacity: 0;
              transition: all 0.3s;
            }
            &.active {
              color: #ea0b06;
              &::after {
                opacity: 1;
              }
            }
          }
        }
      }
      .hl-shop-solution-list {
        display: flex;
        flex-wrap: wrap;
        border-left: 1px solid #e8e8e8;
        > div {
          width: 33.33%;
          padding: 24px;
          border-bottom: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
          cursor: pointer;
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            border-top: 1px solid #e8e8e8;
          }
          > p {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #262600;
            line-height: 24px;
            margin-bottom: 24px;
            transition: all 0.3s;
            > img {
              margin-left: 8px;
            }
          }
          > span {
            font-size: 12px;
            color: #666666;
            line-height: 20px;
            margin-bottom: 24px;
            display: block;
            height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          > div {
            display: flex;
            align-items: flex-end;
            font-size: 18px;
            color: #ea0b06;
            line-height: 24px;
            > span {
              font-size: 12px;
              color: #8c8c8c;
              line-height: 22px;
              margin-left: 4px;
            }
          }
          &:hover {
            > p {
              color: #ea0b06;
            }
          }
        }
      }
    }
    .hl-shop-iot-content {
      display: flex;
      .hl-shop-iot-jx {
        width: 344px;
        margin-right: 24px;
        border: 1px solid #e8e8e8;
        > img {
          display: block;
          width: 100%;
          height: 180px;
        }
        > div {
          padding: 24px;
          > p {
            font-size: 16px;
            color: #262626;
            line-height: 22px;
            margin-bottom: 16px;
          }
          > span {
            display: block;
            font-size: 14px;
            color: #666666;
            line-height: 16px;
          }
        }
      }
      .hl-shop-iot-list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > div {
          width: 436px;
          padding: 24px;
          border: 1px solid #e8e8e8;
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          cursor: pointer;
          &:nth-last-child(1),
          &:nth-last-child(2) {
            margin-bottom: 0;
          }
          > span {
            width: 112px;
            margin-right: 16px;
            > img {
              max-width: 100%;
              display: block;
              margin: auto;
            }
          }
          > div {
            flex: 1;
            > h4 {
              font-size: 16px;
              color: #262626;
              line-height: 22px;
              margin-bottom: 12px;
              transition: all 0.3s;
            }
            > p {
              font-size: 12px;
              color: #999999;
              line-height: 16px;
              max-height: 32px;
              overflow: hidden;
              margin-bottom: 16px;
              ::v-deep img{
                display: none;
              }
            }
            > span {
              display: block;
              font-size: 18px;
              color: #ea0b06;
              line-height: 24px;
            }
          }
          &:hover {
            > div {
              > h4 {
                color: #ea0b06;
              }
            }
          }
        }
      }
    }
    .hl-shop-iot {
      margin-bottom: 48px;
    }
    .hl-shop-app-content {
      display: flex;
      justify-content: space-between;
      > div {
        width: 628px;
        border: 1px solid #d8d8d8;
        height: 384px;
        overflow: hidden;
        .hl-shop-app-list {
          display: flex;
          padding: 16px 24px;
          cursor: pointer;
          > span {
            width: 72px;
            height: 72px;
            margin-right: 24px;
            > img {
              display: block;
              max-width: 100%;
              max-height: 100%;
            }
          }
          > div {
            flex: 1;
            position: relative;
            > h4 {
              font-size: 16px;
              color: #262626;
              line-height: 22px;
              margin-bottom: 12px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            > span {
              display: block;
              font-size: 12px;
              color: #8c8c8c;
              line-height: 16px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            > p {
              position: absolute;
              top: 50%;
              right: 0;
              display: flex;
              align-items: flex-end;
              font-size: 18px;
              color: #ea0b06;
              line-height: 25px;
              transform: translateY(-50%);
              > span {
                margin-left: 4px;
                font-size: 12px;
                color: #8c8c8c;
                line-height: 24px;
              }
            }
          }
        }
      }
      .seamless-warp {
        height: 384px;
        overflow: hidden;
      }
    }
  }
}
</style>
